<div class="row" *ngIf="eventDetails">
	<div class="col-md-6 col-md-push-6">
		<div class="postcard-xs">
			<eze-registration-page-postcard
				[eventDetails]="eventDetails"
			></eze-registration-page-postcard>
		</div>

		<!-- right column on desktop, first section in mobile -->
		<div *ngIf="!profile">
			<eze-login-or-create-account
				(success)="getProfile()"
				[allowGuestLogin]="false"
			></eze-login-or-create-account>
		</div>

		<!-- maintenance mode start -->
		<!-- maintenance mode start -->
		<!-- maintenance mode start -->
		<div
			*ngIf="maintenanceMode; then maintenanceMessage; else routerOutlet"
		></div>

		<ng-template #maintenanceMessage>
			<div class="alert alert-warning">
				<h2>We’ll be back soon!</h2>

				<div class="mb-1">
					Sorry for the inconvenience. We’re performing some
					maintenance at the moment. We’ll be back up shortly!
				</div>
			</div>
		</ng-template>
		<ng-template #routerOutlet>
			<div *ngIf="profile">
				<router-outlet></router-outlet>
			</div>
		</ng-template>
		<!-- maintenance mode end -->
		<!-- maintenance mode end -->
		<!-- maintenance mode end -->
	</div>
	<div class="col-md-6 col-md-pull-6">
		<!-- left column on desktop, second section in mobile -->
		<div class="postcard-lg">
			<eze-registration-page-postcard
				[eventDetails]="eventDetails"
			></eze-registration-page-postcard>
		</div>

		<eze-ez-promo></eze-ez-promo>
	</div>

	<!-- <div class="clearfix"></div> -->
	<!-- <pre>{{eventDetails | json}}</pre> -->
</div>
